import { environment } from "./environment";
import { cookieService } from "./cookie-service";

/** Call Feature Flag as a service (FFAAS) and return a boolean, false if we see any error */
/** TODO: We send the orgId as the anonymousId, since FFAAS doesnt support anonymousId, and so the flags we setup need to use the BDCOrgId as the key */
export async function fetchFeatureFlag(flag, orgId = cookieService.anonymousId(), orgProps = {}) {
    const url = `${environment.ffaas}?op=GetMarketingFlag&flagName=${flag}`;
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify({
        operationName: 'MarketingFlag',
        variables: { flag, orgId, orgProps },
        query: 'query MarketingFlag($flag: String!, $orgId: String!) {\n  getFlag(flag: $flag, orgId: $orgId, orgProps: {}) {\n feature_flag {\n data\n }\n}\n}',
    });


    const featureFlagData = await fetch(url, {
        headers,
        body,
        method: "POST",
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .catch(error => {
            console.error("Error fetching feature flag:", error);
        });

    return featureFlagData?.data?.getFlag?.feature_flag?.data[flag] || false;
}